<style lang="sass" scoped>
h2
  .num
    font-size: 24px
    color: #3B9BFC
    margin-left: 20px
  img
    width: 80px
    position: relative
    top: 10px
.middle
  margin-top: 60px
  padding-top: 25px
  border-top: 1px solid #bfcbd9
  .left, .right
    display: inline-block
    vertical-align: top
  .left
    width: 55%
    .echarts
      margin-top: 15px
      width: 500px
      height: 350px
  .right
    width: 45%
</style>
<style lang="sass">
.echarts .el-loading-mask
  z-index: 1000
.el-table.table-reviewlist
  margin-top: 15px
  .el-loading-mask
    z-index: 1000
  tr
    &.row-success
      td:nth-child(3)
        color: #13CE66
    &.row-defeat
      td:nth-child(3)
        color: #FF4949
    &.row-ing
      td:nth-child(3)
        color: #8492A6
    td:nth-child(2) .cell
      max-width: 235px
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
</style>

<template lang="pug">
.wrapper
  headers(:navNum = "navNum", :username = "username")
  .layout-wrapper
    layout(v-loading="loading")
      template(slot="page")
        h2 认证剩余
          span
            span.num {{allRemain}}
            |&nbsp;&nbsp;次&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            a.charging(v-on:click="charge()" href="javascript: void(0)" target="_blank")
              img(src="../assets/充值.png")
        .middle
          .left
            h3 当前账户认证概览：
              el-tooltip(effect="dark", placement="right")
                div(slot="content") 认证结果为未知，属于认证失败<br/>认证结果为一致或者不一致，均属于认证成功
                i.el-icon-information
            .echarts
              IEcharts(:option="pie")
          .right
            h3 应用概览：
            el-table.table-reviewlist(:data="tableData", height="280", :row-class-name="tableRowClassName")
              el-table-column(prop="appName", label="应用名称", width="200")
              el-table-column(prop="count", label="认证月耗", width="120")
              el-table-column(prop="status", label="应用状态")
              div(slot="empty")
                .add-icon
                  router-link(to="/application/create" style="color:#50bfff;font-size:28px;")
                    .el-icon-plus
                .add-text 暂无数据，立即&nbsp;
                  router-link(to="/application/create" style="color:#50bfff") 创建
</template>

<script>
import headers from '../components/headers'
import layout from '../components/layout'
import IEcharts from 'vue-echarts-v3/src/full.js'
import { mapState } from 'vuex'
import { getCookie } from '../utils/cookie'

export default {
  components: { headers, layout, IEcharts },
  data () {
    return {
      navNum: 1,
      pie: {
        color: ['#73b4d8', '#f49776'],
        legend: {
          data: ['认证成功', '认证失败'],
          right: 0,
          orient: 'vertical'
        },
        tooltip: {},
        series: [{
          type: 'pie',
          radius: '55%',
          data: [
            { value: 0, name: '认证成功' },
            { value: 0, name: '认证失败' }
          ]
        }]
      }
    }
  },
  computed: {
    ...mapState({
      allRemain: state => state.dashboard.allRemain,
      viewList: state => state.dashboard.viewList,
      loading: state => state.dashboard.loading,
      username: state => state.dashboard.username
    }),
    tableData: function () {
      return this.$store.state.dashboard.viewList.map(item => {
        return {
          appName: item.appName,
          count: item.count === null ? 0 : item.count,
          status: item.status === 1 ? '正常' : '删除'
        };
      });
    }
  },
  mounted () {
    const loginToken = getCookie('cookieToken');
    if (!loginToken) {
      setTimeout(() => {
        this.getOverview();
      }, 2000);
    } else {
      this.getOverview();
    }
  },
  methods: {
    async getOverview () {
      await this.$store.dispatch('getOverview', {});
      await this.changePie()
    },
    charge () {
      zhuge.track(' 一键登录控制台 - 点击充值', {
        账号: this.username
      });
      window.open('https://console.upyun.com/billing/oneclicklogin/')
    },
    tableRowClassName (row, index) {
      if (row.status === '正常') {
        return 'row-success';
      } else if (row.status === '删除') {
        return 'row-defeat';
      }
    },
    changePie () {
      const pieDate = JSON.parse(localStorage.getItem('pieDate')).data;
      this.pie.series[0].data[0].value = pieDate.successCount
      this.pie.series[0].data[1].value = pieDate.failCount
    }
  }
}
</script>



// WEBPACK FOOTER //
// dashboard.vue?85196ae2